import { puzzles } from "../../../../../../puzzles";
import { parseSGS, type SGSCachedData } from "../../../parseSGS";

let cachedData: Promise<SGSCachedData> | null = null;
export async function sgsDataPyraminx() {
  return (cachedData ??= uncachedSGSDataPyraminx());
}

export async function sgsDataPyraminxFixedOrientation(): Promise<SGSCachedData> {
  return {
    ordering: (await sgsDataPyraminx()).ordering.slice(2),
  };
}

// TODO: Reduce info.
async function uncachedSGSDataPyraminx(): Promise<SGSCachedData> {
  return parseSGS(
    await puzzles["pyraminx"].kpuzzle(),
    `SubgroupSizes 12 9 12 3 10 3 8 6 2 3 3 3 3

Alg B
Alg B'
Alg y
Alg B y
Alg B' y
Alg y'
Alg B y'
Alg B' y'
Alg BR'
Alg B BR'
Alg B' BR'

Alg L
Alg L'
Alg L F
Alg L' F
Alg F
Alg L F'
Alg L' F'
Alg F'

Alg L B' U L' B
Alg L U L'
Alg L U' L'
Alg L U L' U'
Alg B' U B
Alg B' U' B
Alg B' U' B U
Alg L U' L' R
Alg L U' L' R'
Alg L' R' L
Alg L' R' L R

Alg R
Alg R'

Alg R' U R
Alg R' U' R
Alg R' U R U'
Alg B U B'
Alg B U' B'
Alg R B' R' B
Alg L R L' R U' R
Alg R L R' L'
Alg L' R' U R L

Alg U
Alg U'

Alg R U R' U'
Alg U R U' R'
Alg L' U' L U
Alg U' L' U L
Alg U L R' L' R U'
Alg U' R' L R L' U
Alg L' U' L U' R U' R'

Alg R U' R' U
Alg L' U L U'
Alg U' R U R'
Alg U L' U' L
Alg L R' L' R L' U L U'

Alg L' U L U' L R' L' R

Alg b
Alg b'

Alg l
Alg l'

Alg r
Alg r'

Alg u
Alg u'`,
  );
}
